import { useEffect } from "react";
import { queryKeys } from "@/constants";
import { useQuery } from "@tanstack/react-query";
import { AuthorizationItem } from "@/models/request";
import { NotifyService } from "@/helpers/notify";
import { requestApi } from "@/services/request";

interface UseGetListAuthorizationProps {
  enabledToastError?: boolean;
  filterFn?: (data: AuthorizationItem[]) => AuthorizationItem[];
}

export const useGetListAuthorization = (
  { enabledToastError = false, filterFn }: UseGetListAuthorizationProps = {
    enabledToastError: false,
  }
) => {
  const query = useQuery({
    queryKey: [queryKeys.authorization],
    queryFn: async () => {
      const { data } = await requestApi.getListAuthorization();
      if (!data) return [];

      if (filterFn) {
        return filterFn(data);
      }

      return data;
    },
  });

  useEffect(() => {
    if (query.error) {
      // eslint-disable-next-line no-console
      console.error("useGetListAuthorization", query.error.message);
      enabledToastError && NotifyService.error(query.error.message);
    }
  }, [query.error, enabledToastError]);

  return query;
};
